<template>
  <div>
    <adx-top-alert ref="alert" :status="status" :message="message" visible="visible"/>
    <button @click="show">Show</button>
  </div>
</template>

<script>
import TopAlert from '@/components/AlertWide'
import GridCard from '@/components/Grid/Card'

export default {
  name: 'adx-topalert',
  components: {
    'adx-top-alert': TopAlert,
    'grid-card': GridCard
  },
  props: {
    
  },
  data() {
    return {
      status:"Success!",
      message:"Your file has sent successfully",
      visible:true,
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    show(){
      var child = this.$refs.alert;
      child.fadeout();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

